/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import _objectSpread from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 1,
  class: "type_row"
};
var _hoisted_4 = ["onClick"];
import { reactive, watch } from "vue";
export default {
  __name: 'echartsCarHeader',
  props: {
    title: {
      default: "客户拜访新增数",
      type: String
    },
    order: {
      default: "desc",
      type: String
    },
    count: {
      default: 10,
      type: Number
    },
    type: {
      default: "区域",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    isOnlyName: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onScreen"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emit = __emit;
    var props = __props;
    var data = reactive({
      order: props.order,
      type: props.type
    });
    var type_list = ref(["区域", "个人"]);
    watch(() => {
      return data;
    }, val => {
      emit("onScreen", _objectSpread({
        name: props.name
      }, val));
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      var _component_el_option = __unplugin_components_0;
      var _component_el_select = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1), !__props.isOnlyName ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        modelValue: _unref(data).order,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(data).order = $event),
        class: "m-2",
        placeholder: "Select",
        size: "small",
        style: {
          "width": "120px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: '最高TOP' + __props.count,
          value: "desc"
        }, null, 8, ["label"]), _createVNode(_component_el_option, {
          label: '最低TOP' + __props.count,
          value: "asc"
        }, null, 8, ["label"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), !__props.isOnlyName ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(type_list), (type_item, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass([type_item == _unref(data).type ? 'isactive' : '']),
          onClick: $event => _unref(data).type = type_item
        }, _toDisplayString(type_item), 11, _hoisted_4);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};